<template>
  <div
    ref="editTooltipWrap"
    class="link-edit-wrap"
  >
    <div class="link">
      <div class="link-url">
        {{ url }}
      </div>
    </div>
    <div
      class="item pt usn"
      @click.stop="copyLink"
    >
      {{ translate('copy') }}
    </div>
    <div
      id="edit"
      class="item pt usn"
      @click.stop="editLink"
    >
      {{ translate('edit') }}
    </div>
  </div>
</template>

<script>
import showLinkPopup from '../mixins/showLinkPopup';

export default {
  mixins: [showLinkPopup],

  props: {
    url: {
      type: String,
      required: true,
    },

    text: {
      type: String,
      required: true,
    },

    range: {
      type: Object,
      required: true,
    },

    editorId: {
      type: String,
      required: true,
    },
  },

  computed: {
    tooltipLinkStyle() {
      let maxWidth;
      if (this.editorId.includes('comment-')) {
        maxWidth = 100;
      }
      return {
        'max-width': `${maxWidth}px`,
      };
    },

    editor() {
      return this.$store.getters.editor(this.editorId);
    },
  },

  methods: {
    copyLink() {
      this.editor.commands.hideLinkTooltip();
      navigator.clipboard.writeText(this.url);

      const notification = {
        message: this.translate('linkCopiedToClipboard'),
        icon: 'link-st',
        duration: 4000,
      };
      this.$store.dispatch('addUiNotification', notification);
      this.editor.commands.focus();
    },

    editLink() {
      this.editor.commands.hideLinkTooltip();
      this.showPopup({
        editorId: this.editorId,
        insertLink: true,
        selectedText: this.text,
        from: this.range.from,
        to: this.range.to,
        url: this.url,
        editor: this.editor,
      });
    },
  },
};
</script>

<style lang="scss">
.link-edit-wrap {
  max-width: 290px;
  margin: 4px 0;
  height: 34px;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  overflow: hidden;
  @apply text-text-default bg-important-bg border border-solid border-important-border;
  .link {
    max-width: $linkTooltipWidth;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
    .link-url {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;
      line-height: 18px;
      margin-left: 8px;
      margin-right: 4px;
      cursor: text;
      @apply text-text-default;
    }
  }
  .item {
    border: 0;
    border-left: 1px solid;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 47px;
    height: 100%;
    @apply text-text-default border-dividers-default hover:bg-important-hover;
  }
}

.ProseMirror-resizing {
  .link-edit-wrap {
    display: none !important;
    .link {
      .link-url {
        cursor: col-resize !important;
      }
    }
  }
}
@media (max-width: 768px) {
  .link-edit-wrap {
    .link {
      max-width: 80px !important;
    }
  }
}
@media (max-width: 1280px) {
  .link-edit-wrap {
    .link {
      max-width: 100px;
    }
  }
}
</style>
